export const MESSAGES_PARAMS = {
    HISTORY_LIMIT: {
        ALLOW_NEGATIVE: false,
        DECIMAL_SCALE: 0,
    },
    MAX_TOKENS: {
        DECIMAL_SCALE: 0,
        ALLOW_NEGATIVE: false
    }
};
